import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalsService } from 'src/app/_core/services/modals.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent implements OnInit {
  instance;

  constructor(private modalService: ModalsService) {}

  ngOnInit(): void {
    this.instance = this.modalService.params;
  }

  confirm() {
    // Info-only mode (e.g. ineligible-charity notice): the OK button just
    // acknowledges and dismisses. Skip emitResponse so it doesn't re-trigger
    // the caller's modalResponse$ handler (which would re-run the action).
    if (this.instance?.infoOnly) {
      this.closeModal();
      return;
    }

    this.modalService.emitResponse(true);
    this.closeModal();
  }

  closeModal() {
    this.modalService.closeModal();
  }
}
